import { HttpClient } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';

import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { DebugMissingTranslationHandler } from './debug-missing-translation.handler';
import { HttpLoaderFactory } from './translate.loader';

export function provideTranslateModule() {
  return importProvidersFrom(
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: DebugMissingTranslationHandler,
      },
      defaultLanguage: 'uk',
    })
  );
}
